import { render, staticRenderFns } from "./Template-Detail.vue?vue&type=template&id=b3e6fc0c&"
import script from "./Template-Detail.vue?vue&type=script&lang=js&"
export * from "./Template-Detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports